<template>
  <div class="NominaDiasFestivos">
    <md-layout md-flex="100" md-gutter="24" md-align="center">
      <md-layout md-column md-flex-xsmall="100" md-flex-small="80" md-flex-medium="60" md-flex-large="40" md-flex-xlarge="30">
        <md-table-card class="m-t-16">
          <md-toolbar>
            <h1 class="md-title">Días festivos</h1>
            <md-button class="md-icon-button md-raised md-accent" @click.native="abrirModal()">
              <md-icon>add</md-icon>
              <md-tooltip md-direction="left">Agregar día festivo</md-tooltip>
            </md-button>
          </md-toolbar>
          <md-table>
            <md-table-header>
              <md-table-row>
                <md-table-head></md-table-head>
                <md-table-head>Fecha</md-table-head>
                <md-table-head>Motivo</md-table-head>
              </md-table-row>
            </md-table-header>
            <md-table-body>
              <md-table-row v-for="d in dias" :key="d.dia">
                <md-table-cell>
                  <md-button class="md-icon-button" @click.native="eliminarDia(d.dia)">
                    <md-icon>delete</md-icon>
                    <md-tooltip md-direction="right">Eliminar {{d.fecha_dia}}</md-tooltip>
                  </md-button>
                </md-table-cell>
                <md-table-cell> {{d.fecha_dia}} </md-table-cell>
                <md-table-cell> {{d.motivo_dia}} </md-table-cell>
              </md-table-row>
            </md-table-body>
          </md-table>
        </md-table-card>
      </md-layout>
    </md-layout>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="modalNuevoDia">
      <md-dialog-title>Registrar día festivo</md-dialog-title>
      <md-dialog-content>
        <md-input-container v-bind:class="{ 'md-input-invalid': v.fecha_dia }">
          <label>dia/mes/año</label>
          <md-input v-mask="'##/##/####'" v-model="dia.fecha_dia" required placeholder="Fecha"></md-input>
        </md-input-container>
        <md-input-container v-bind:class="{ 'md-input-invalid': v.motivo_dia }">
          <label>Motivo</label>
          <md-input maxlength="255" v-model="dia.motivo_dia" required></md-input>
        </md-input-container>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="cerrarModalDia()">Cancelar</md-button>
        <md-button class="md-raised md-primary" @click.native="guardarDia()">Guardar</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
export default {
  name: "NominaDiasFestivos",
  methods: {
    obtenerDias() {
      this.$http
        .post("dias", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            if (response.status === 200 && "dias" in response.body) {
              this.dias = response.body.dias;
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    abrirModal() {
      this.$refs["modalNuevoDia"].open();
    },
    cerrarModalDia() {
      this.$refs["modalNuevoDia"].close();
      this.dia.fecha_dia = null;
      this.dia.motivo_dia = null;
    },
    guardarDia() {
      if (this.validarCamposDia()) {
        this.$http
          .post("dias/guardar", {
            token: this.$session.get("token"),
            data: this.dia
          })
          .then(
            response => {
              if (response.status === 200 && "msg" in response.body) {
                Snackbar.show({
                  text: response.body.msg,
                  actionText: "Cerrar",
                  pos: "top-right",
                  showAction: false
                });
                this.cerrarModalDia();
                this.obtenerDias();
              } else {
                Snackbar.show({
                  text: response.body.error,
                  actionText: "Cerrar",
                  pos: "top-right",
                  showAction: false,
                  backgroundColor: "#F44336",
                  actionTextColor: "#FFF"
                });
              }
            },
            response => {
              Snackbar.show({
                text: "No se pudo establecer conexión con el servidor.",
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          );
      }
    },
    eliminarDia(d) {
      this.$http
        .post("dias/eliminar", {
          token: this.$session.get("token"),
          dia: d
        })
        .then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              Snackbar.show({
                text: response.body.msg,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false
              });
              this.obtenerDias();
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text:
                "No se pudo establecer conexión con el servidor para eliminar el día",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    validarCamposDia() {
      this.v.fecha_dia = !this.dia.fecha_dia ? true : false;
      this.v.motivo_dia = !this.dia.motivo_dia ? true : false;
      if (this.v.fecha_dia || this.v.motivo_dia) {
        Snackbar.show({
          text: "Por favor llene todos los campos.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created() {
    this.obtenerDias();
  },
  data() {
    return {
      dias: [],
      dia: {
        fecha_dia: null,
        motivo_dia: null
      },
      v: {
        fecha_dia: null,
        motivo_dia: null
      }
    };
  }
};
</script>


// WEBPACK FOOTER //
// NominaDiasFestivos.vue?62d8de08